// "Créditer une journée travaillée" — récup credit for a day worked on
// a weekend or holiday (proto CgRecupModal). Only off-days are pickable;
// full day = +1 j, half day = +0,5 j. Posts a RECUP MANUAL_ADDITION.
import { useState } from 'react';
import { toast } from '../../store/toast.js';
import { useEmployees, useManualTx } from '../../api/hooks.js';
import { MiniMonth, useHolidayMap, cgFmtLong, cgNum, cgToday, cgD, entityById, shiftYm } from './common.js';

const offLabel = (iso: string, holidays: Map<string, string>) => {
  const hol = holidays.get(iso);
  if (hol) return `Jour férié · ${hol}`;
  const dow = cgD(iso).getUTCDay();
  return dow === 5 ? 'Vendredi' : dow === 6 ? 'Samedi' : 'Jour ouvrable';
};

export function CreditRecupModal({ preset, onClose }: { preset: { empId?: string | null }; onClose: () => void }) {
  const employees = useEmployees();
  const manual = useManualTx();

  const [empId, setEmpId] = useState<string | null>(preset.empId ?? null);
  const [demi, setDemi] = useState(false);
  const [date, setDate] = useState<string | null>(null);
  const [motif, setMotif] = useState('');
  const [m0, setM0] = useState(cgToday().slice(0, 7));
  const m1 = shiftYm(m0, 1);
  const holidays = useHolidayMap(m0, m1);

  const list = employees.data ?? [];
  const effEmp = empId ?? list[0]?.id ?? '';
  const j = demi ? 0.5 : 1;

  const submit = async () => {
    if (!effEmp || !date) return;
    if (!motif.trim()) { toast.danger('Motif requis — inventaire, permanence, garde…'); return; }
    try {
      const r = await manual.mutateAsync({ employeeId: effEmp, type: 'RECUP', kind: 'MANUAL_ADDITION', amount: j, date, reason: motif.trim() });
      toast.success(`+${cgNum(j)} j de récupération crédités · stock ${cgNum(r.current)} j`);
      onClose();
    } catch {
      toast.danger('Échec du crédit de récup.');
    }
  };

  return (
    <div className="cg-veil center" onClick={onClose}>
      <div className="cg-modal md" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="cg-mo-head">
          <div>
            <div className="sb-mo-title">Créditer une journée travaillée</div>
            <div className="sb-mo-sub">Seuls les vendredis, samedis et jours fériés ouvrent droit à récupération · 1 journée travaillée = 1 jour de récup.</div>
          </div>
          <button className="sb-dr-x" onClick={onClose} aria-label="Fermer">✕</button>
        </div>
        <label className="sb-dr-lbl">Employé</label>
        <select className="cg-select" value={effEmp} onChange={(e) => setEmpId(e.target.value)}>
          {list.map((e) => {
            const ent = entityById(e.entityId);
            return <option key={e.id} value={e.id}>{e.name}{ent ? ` — ${ent.short}` : ''}</option>;
          })}
        </select>
        <label className="sb-dr-lbl">Jour travaillé · week-ends et fériés uniquement</label>
        <div className="cg-mo-calhead">
          <button className="gm-mn-arrow" onClick={() => setM0(shiftYm(m0, -1))}>‹</button>
          <span className="cg-mo-calrange">{date ? `${cgFmtLong(date)} · ${offLabel(date, holidays)}` : 'Sélectionnez un jour non ouvrable'}</span>
          <button className="gm-mn-arrow" onClick={() => setM0(shiftYm(m0, 1))}>›</button>
        </div>
        <div className="cg-mm-pair">
          <MiniMonth month={m0} sel={{ from: date, to: date }} onlyOff onPick={setDate} holidays={holidays} />
          <MiniMonth month={m1} sel={{ from: date, to: date }} onlyOff onPick={setDate} holidays={holidays} />
        </div>
        <label className="sb-dr-lbl">Durée travaillée</label>
        <div className="cg-hgrid two">
          <button type="button" className={'cg-hbtn' + (!demi ? ' on' : '')} onClick={() => setDemi(false)}>Journée complète<i>+1,0 j de récup</i></button>
          <button type="button" className={'cg-hbtn' + (demi ? ' on' : '')} onClick={() => setDemi(true)}>Demi-journée<i>+0,5 j de récup</i></button>
        </div>
        <label className="sb-dr-lbl">Motif</label>
        <input className="cg-search" placeholder="Inventaire, permanence, go-live, garde…" value={motif} onChange={(e) => setMotif(e.target.value)} />
        <div className="cg-proj" style={{ marginTop: 16 }}>
          <div className="cg-proj-l">{date ? offLabel(date, holidays) : 'Aucun jour sélectionné'}</div>
          <div className="cg-proj-r"><b className="gm-mono ok">+{cgNum(j)} j</b><span>de récupération</span></div>
        </div>
        <div className="cg-mo-foot">
          <button className="cg-ghost" onClick={onClose}>Annuler</button>
          <button className="gm-attn-go" disabled={!date || !motif.trim() || manual.isPending} onClick={submit}>Créditer</button>
        </div>
      </div>
    </div>
  );
}
